import React from 'react';
import NavActivites from '../navactivities/navactivities';
import Header from '../../../header/header';
import Footer from '../../../footer/footer';
import ImageSlider from './carrousselathletisme';

const Athletisme = (props) => {

  return (
    <div>
    <Header />
  <div id="stage">
    <div className="container">
        <div className="section-title">
        <NavActivites />
          <h2>Athletisme</h2>
          <br></br>
          <p>L’athlétisme est le socle, la base de nombreux sports. 
            <br></br>Un sport qui pousse au développement de l’individu, qui pousse à se dépasser, aussi bien physiquement que mentalement.</p>
          </div>
          <ImageSlider />
<br></br>
<br></br> 
<br></br>
<div className="stage-text">
<p> Marcher- Courir – Sauter – Lancer : Ce sont les gestes fondamentaux de l’athlétisme. 
  <br></br>Ce sont aussi des gestes de la vie courante, c’est pourquoi la première approche de l’athlétisme ne sera pas technique mais ludique.
  <br></br> Pratiqués en nature ou dans un stade, vous pourrez réaliser dans un premier temps des activités multiformes sollicitant toutes les grandes fonctions.</p>
<br></br>
<br></br>
<h3>Les différentes disciplines de l’Athlétisme :</h3>
<br></br>

<h4>Les courses :</h4>
<p>Elles aident à améliorer la respiration, à entretenir le cœur.
  <br></br>Il existe :
</p>
<ul>
  <p><li>Le sprint</li></p>
  <p><li>Les haies</li></p>
  <p><li>Le fond</li></p>
  <p><li>Les relais</li></p>
  <p><li>La marche athlétique</li></p>

</ul>

<br></br>
<h4>Les lancers :</h4>
<p>Les lancers consistent à envoyer le plus loin possible un engin de forme diverses. 
  <br></br>Il existe :
</p>
<ul>
  <p><li>Le javelot</li></p>
  <p><li>Le poids</li></p>
  <p><li>Le marteau</li></p>
  <p><li>Le disque</li></p>
</ul>

<br></br>
<h4>Les sauts :</h4>
<p>Les sauts consistent à bondir le plus haut ou le plus loin possible.
  <br></br>Il existe :
</p>
<ul>
  <p><li>En hauteur</li></p>
  <p><li>En longueur</li></p>
  <p><li>A la perche</li></p>
  <p><li>Le triple saut</li></p>
</ul>
<br></br>
<br></br>
<h3>Pour les 3 à 12 ans :</h3>
<p>Pour les plus petits, l'objectif pédagogique est de développer sa motricité car à cet âge, il doit maîtriser son équilibre, construire sa latéralisation, synchroniser ses mouvements et surtout enrichir son répertoire moteur.
  <br></br>
  Pour les plus grands, l'objectif est similaire mais reposera sur les compétences acquises et aura donc un axe de travail différent.
  <br></br>
  Chaque séance et chaque situation lui permettront de s'épanouir et surtout de s'extraire du cocon familial, de partager et d'accepter les autres.
</p>
</div>




</div>

        </div>
      < Footer />

    </div>

  );
};
export default Athletisme;